import { ObjectStorage } from "../ObjectStorage";

class WalletAsyncStorage extends ObjectStorage {
    public isSecure = true;
    public key = 'wallet_async';
    //public oldKey = 'wallet';
}

export default WalletAsyncStorage.getInstance(WalletAsyncStorage);
